/* eslint-disable */
export default {
  dncAlert: 'Dieser Kontakt ist auf einer "Nicht anrufen"-Liste.',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
